import {
  PublicClientApplication,
  type Configuration,
  type SilentRequest,
} from "@azure/msal-browser";
import { appConfig } from "@/config/appConfig";

// Single PublicClientApplication instance for the whole app. Created once at module load.
// When MSAL is disabled (dev/stub mode), we still construct an instance because main.tsx checks
// the flag before wiring MsalProvider — keeping this construction pure means we don't crash if
// the flag is wrong.

const config: Configuration = {
  auth: {
    clientId: appConfig.msal.clientId || "00000000-0000-0000-0000-000000000000",
    // Multi-tenant app: users from any allowed org sign in with their home-tenant identity (no
    // guest invite). Leave msal.tenantId empty so we use the /organizations endpoint. Setting a
    // tenant GUID here pins login to that single tenant and breaks cross-org sign-in
    // (AADSTS90072). Tenant allow-listing is enforced on the app registration + API issuer check,
    // not here.
    authority: appConfig.msal.tenantId
      ? `https://login.microsoftonline.com/${appConfig.msal.tenantId}`
      : "https://login.microsoftonline.com/organizations",
    redirectUri:
      typeof window !== "undefined" ? window.location.origin : "http://localhost:3000",
    postLogoutRedirectUri:
      typeof window !== "undefined" ? window.location.origin : "http://localhost:3000",
    navigateToLoginRequestUrl: true,
  },
  cache: {
    // localStorage (not sessionStorage) so the signed-in session is shared across browser tabs.
    // Opening a request in a new tab (e.g. the Pre-Verification ID link on the detail screen) then
    // picks up the existing account silently instead of forcing an interactive re-login.
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const pca = new PublicClientApplication(config);

export const tokenRequest: Pick<SilentRequest, "scopes"> = {
  scopes: appConfig.msal.apiScope ? [appConfig.msal.apiScope] : [],
};
